import module from 'recursoshumanos/module.js'
import template from './template.html'

export class recursoshumanosVisorlotesLoteEliminarComponent {
  constructor (RecursosHumanosVisorLotesLote) {
    this.RecursosHumanosVisorLotesLote = RecursosHumanosVisorLotesLote
    this.onClose = null
    this.folio = null
  }

  procesar () {
    if (this.procesando) return
    this.procesando = true

    this.RecursosHumanosVisorLotesLote.delete(this.folio)
    .then(() => (this.procesado = true))
    .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.onClose({$event: {data: this.procesado}})
  }
}

module.component('recursoshumanosVisorlotesLoteEliminar', {
  controller: recursoshumanosVisorlotesLoteEliminarComponent,
  template,
  bindings: {
    folio: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/visorlotes/lote/eliminar/component.js